import { EhrAppointmentKind, EhrCoachSpecialty, UserGoalKind } from '@src/types'

export const DEFAULT_VIDEO_CALL_INFO = {
  title: 'Video Call',
  buttonText: 'Schedule',
}
export const INSURANCE_BASED_VIDEO_CALLS_PROMOTION_SLOGAN =
  "$0 out of pocket with most insurance. You won't be charged."
export const VIDEO_CALL_POLICY_URL = 'https://www.nutrisense.io/legal/video-call-policy'
export const INSURANCE_CHECK_IN_PROGRESS_MESSAGE =
  'We are checking your insurance to make sure it covers video\
 calls with your nutritionist. You should hear back from us at least 24 hours before your call.'
export const VIDEO_CHAT_AND_PAID_ASYNC_CHAT = {
  title: 'Message your Nutritionist',
  description: 'Expect a reply in 1 business day',
  buttonText: 'Message',
}

export const HEALTH_COACHING_VIDEO_CHAT = {
  title: 'Message your Health Coach',
  description: 'Expect a reply in 1 business day',
  buttonText: 'Message',
}
export const NO_CURRENT_CHAT_SUPPORT = {
  title: 'Unlimited Chat Support',
  description: 'Unlimited 1-1 chat',
  buttonText: 'Upgrade',
}

export const VIDEO_CALL_DURATION_OPTIONS = [
  { value: EhrAppointmentKind.Followup_30, text: '30 min' },
  { value: EhrAppointmentKind.Followup, text: '60 min' },
]

export const SLOT_TAKEN_ERROR = 'slot is already taken'
export const NUTRITIONIST_NOT_LICENSED_ERROR = 'not licensed'
export const VIDEO_CALL_PAST_APPOINTMENT_BUFFER_MINUTES = 15

export const COACH_SPECIALTIES_BY_USER_GOAL_NAME: Partial<
  {
    [key in UserGoalKind]: EhrCoachSpecialty[] | undefined
  }
> = {
  [UserGoalKind.LoseWeight]: [EhrCoachSpecialty.WeightConcerns, EhrCoachSpecialty.Bariatric],
  [UserGoalKind.ImproveGlucoseValues]: [
    EhrCoachSpecialty.GutHealth,
    EhrCoachSpecialty.MindfulEating,
    EhrCoachSpecialty.EatingDisorders,
    EhrCoachSpecialty.PrediabetesDiabetes,
    EhrCoachSpecialty.HealthOptimization,
    EhrCoachSpecialty.FoodAllergies,
  ],
  [UserGoalKind.LearnAboutGlucoseLevels]: [
    EhrCoachSpecialty.GutHealth,
    EhrCoachSpecialty.MindfulEating,
    EhrCoachSpecialty.EatingDisorders,
    EhrCoachSpecialty.PrediabetesDiabetes,
    EhrCoachSpecialty.HealthOptimization,
    EhrCoachSpecialty.FoodAllergies,
  ],
  [UserGoalKind.OptimizeFitnessPerformance]: [EhrCoachSpecialty.SportsPerformance],
  [UserGoalKind.ManageChronicCondition]: [
    EhrCoachSpecialty.WomensHealth,
    EhrCoachSpecialty.PrenatalNutrition,
    EhrCoachSpecialty.Fertility,
    EhrCoachSpecialty.HealthOptimization,
    EhrCoachSpecialty.HealthyAging,
    EhrCoachSpecialty.HormonalHealth,
    EhrCoachSpecialty.AutoimmuneConditions,
    EhrCoachSpecialty.ThyroidDisorders,
    EhrCoachSpecialty.ChronicFatigue,
    EhrCoachSpecialty.Osteoporosis,
    EhrCoachSpecialty.KidneyStones,
  ],
  [UserGoalKind.PreventDisease]: [
    EhrCoachSpecialty.HeartDisease,
    EhrCoachSpecialty.MensHealth,
    EhrCoachSpecialty.Cancer,
    EhrCoachSpecialty.ThyroidDisorders,
    EhrCoachSpecialty.HealthyAging,
    EhrCoachSpecialty.HealthOptimization,
    EhrCoachSpecialty.Bariatric,
    EhrCoachSpecialty.IntegrativeFunctionalNutrition,
    EhrCoachSpecialty.MetabolicHealth,
    EhrCoachSpecialty.StressManagement,
    EhrCoachSpecialty.Osteoporosis,
    EhrCoachSpecialty.KidneyStones,
  ],
  [UserGoalKind.PromoteLongevity]: [
    EhrCoachSpecialty.HeartDisease,
    EhrCoachSpecialty.MensHealth,
    EhrCoachSpecialty.Cancer,
    EhrCoachSpecialty.ThyroidDisorders,
    EhrCoachSpecialty.HealthyAging,
    EhrCoachSpecialty.HealthOptimization,
    EhrCoachSpecialty.Bariatric,
    EhrCoachSpecialty.IntegrativeFunctionalNutrition,
    EhrCoachSpecialty.MetabolicHealth,
    EhrCoachSpecialty.StressManagement,
    EhrCoachSpecialty.Osteoporosis,
  ],
  [UserGoalKind.Other]: [
    EhrCoachSpecialty.HeartDisease,
    EhrCoachSpecialty.MensHealth,
    EhrCoachSpecialty.Cancer,
    EhrCoachSpecialty.ThyroidDisorders,
    EhrCoachSpecialty.HealthyAging,
    EhrCoachSpecialty.HealthOptimization,
    EhrCoachSpecialty.Bariatric,
    EhrCoachSpecialty.IntegrativeFunctionalNutrition,
    EhrCoachSpecialty.MetabolicHealth,
    EhrCoachSpecialty.StressManagement,
    EhrCoachSpecialty.Osteoporosis,
    EhrCoachSpecialty.KidneyStones,
  ],
}
